export enum ETipoFormaPagamento {
    Dinheiro = 1,
    TransferenciaDeposito = 2,
    PIX = 3,
    Boleto = 4,
    CartaoCredito = 5,
    CartaoDebito = 6,
}
